import { WatchQueryFetchPolicy } from '@apollo/client';
import { ActivitiesFontSize, LanguageCodes } from 'global/constants';
import type {
  GetDraftLessonActivitiesQuery,
  GetDraftLessonActivitiesQueryVariables,
} from '../lesson-builder.graphql.generated';
import useUserData from 'approot/shared/user/user-data';
import { useActivityBuilderTheme } from '../theme/activity-builder-theme';
import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import { GET_DRAFT_LESSON_ACTIVITIES } from '../lesson-builder.graphql';
import { useGetInteractiveLessonParams } from '../activity-builder.hooks';

type Props = {
  contentId?: number;
  fetchPolicy?: WatchQueryFetchPolicy;
  skip?: boolean;
  language?: LanguageCodes;
  onComplete?: (res: GetDraftLessonActivitiesQuery) => void;
};

export const useGetDraftLessonActivities = ({
  contentId,
  fetchPolicy = 'cache-first',
  skip,
  language,
}: Props) => {
  const { userClassId } = useGetInteractiveLessonParams();
  const { isSignedIn } = useUserData();
  const { updateFontSize } = useActivityBuilderTheme();

  const { data, loading, error } = useLoggingQuery<
    GetDraftLessonActivitiesQuery,
    GetDraftLessonActivitiesQueryVariables
  >(
    GET_DRAFT_LESSON_ACTIVITIES,
    {
      skip: !!(!contentId || skip),
      fetchPolicy,
      variables: {
        input: {
          classId: userClassId,
          contentId: contentId || 0,
          language,
        },
      },
      onCompleted: res => {
        if (res.getDraftLessonActivities.styles) {
          updateFontSize(
            res.getDraftLessonActivities.styles.fontSize as ActivitiesFontSize
          );
        }
      },
    },
    isSignedIn
  );

  return {
    data: data?.getDraftLessonActivities,
    loading,
    error,
  };
};
